import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewTabs } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { AgentHistory, AgentModels, AgentFeatures, AiModelsManager } from "./components";
import styles from "./DSIAgents.module.css";
import { useApi } from "../../../../common/hooks";
import { setIsSuccessAgentsImport } from "../../slice/dsi-slice";
import { AiAgentsService, AiWorkflowService } from "../../../../api";
import { WorkFlowHistory, WorkflowModels } from "../dsi-workflow/components";
import ExportImport from "../components/export-import/ExportImport";

export default function DSIAgents() {
	const { call: exportAgents } = useApi(AiAgentsService.exportAgents);
	const { call: importAgents } = useApi(AiAgentsService.importAgents);
	const { call: exportWorkflows } = useApi(AiWorkflowService.exportWorkflows);
	const { call: importWorkFlows } = useApi(AiWorkflowService.importWorkFlows);
	const [selectedTab, setSelectedTab] = useState(0);
	const [isAgent, setIsAgent] = useState(true);
	const navigate = useNavigate();
	const urlParams = useParams();
	const { tab, subTab } = useParams();
	const tabs = useMemo(
		() => [
			{ label: translate("dsi.agents.tab.models.title"), param: "agent-model", component: <AgentModels /> },
			{
				label: translate("dsi.agents.tab.ai-models.title"),
				param: "ai-models",
				component: <AiModelsManager />,
			},
			{ label: translate("dsi.agents.tab.history.title"), param: "agent-history", component: <AgentHistory /> },
			{ label: translate("dsi.agents.tab.features.title"), param: "agent-feature", component: <AgentFeatures /> },
			{
				label: translate("dsi.workflows.tab.models.title"),
				param: "workflow-model",
				component: <WorkflowModels />,
			},
			{
				label: translate("dsi.workflows.tab.history.title"),
				param: "workflow-history",
				component: <WorkFlowHistory />,
			},
		],
		[]
	);
	useEffect(() => {
		if (subTab) {
			const index = tabs.findIndex((t) => t.param === subTab);
			if (index >= 0) {
				setSelectedTab(index);
			}
		}
	}, [tabs, subTab]);
	useEffect(() => {
		if (!urlParams.subTab) {
			setIsAgent(true);
		} else {
			setIsAgent(urlParams.subTab.startsWith("agent-"));
		}
	}, [urlParams]);
	const handleChangeSelectedTab = (_, newTab) => {
		const { param } = tabs[newTab];
		setSelectedTab(newTab);
		if (tab && param) {
			navigate(`/dsi/${tab}/${param}`, { replace: true });
		}
	};
	return (
		<div className={styles.main}>
			<div className={styles.header}>
				<div className={styles.tabs}>
					<ViewTabs
						noPadding
						noShadow
						selectedTab={selectedTab}
						tabClassName={styles.tab}
						tabs={tabs}
						onChange={handleChangeSelectedTab}
					/>
				</div>
				{(selectedTab === 0 || selectedTab === 4) && (
					<ExportImport
						currentTab={selectedTab}
						onExport={isAgent ? exportAgents : exportWorkflows}
						onImport={isAgent ? importAgents : importWorkFlows}
						onSuccessImport={setIsSuccessAgentsImport}
					/>
				)}
			</div>
			{tabs[selectedTab].component}
		</div>
	);
}
